import { createSlice } from "@reduxjs/toolkit";
import { INotificationCountSlice } from "../../../models/master/notification";


const initialNotificationCountState: INotificationCountSlice = {
    notificationCounts : undefined
};

const notificationCountSlice = createSlice({
  name: "notificationCount",
  initialState: initialNotificationCountState,
  reducers: {
    setNotificationCount: (state, action: { payload: any }) => {
      state.notificationCounts = action.payload;
    },
  },
});

export const { setNotificationCount } =
notificationCountSlice.actions;

const notificationCountReducers = notificationCountSlice.reducer;

export type notificationCountState = ReturnType<typeof notificationCountReducers>;

export default notificationCountReducers;
